module.exports = __webpack_public_path__ + "img/product-placeholder-78.93dad71.png";